<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />

    <el-select v-model="query.siteIds[0]" size="small" @change="onSearchBtnClick">
      <el-option
        v-for="site in filterSites"
        :key="site.id"
        :value="site.id"
        :label="site.name"
      />
    </el-select>

    <completed-query v-model="query.isAuditCompleted" @change="onAuditCompletedChanged" />

    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <template #header>
        <unit-switch :default-unit-prop.sync="unitProp" @change="onUnitPropChange" />
      </template>

      <dust-haze-chart-group
        v-for="(factorChartGroup, index) in factorChartGroups"
        :key="`${currentSite.id}-${index}`"
        ref="chart-groups"
        :site="currentSite"
        :data-config="dataList[0]"
        :default-factor-ids="factorChartGroup"
        :unit-prop="unitProp"
        @rendered="onChartRendered"
      />
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import LayoutContent from '../../../../components/Layout/Content'
import DataTimeQuery from '../../../../components/Data/Query/DataTimeQuery'
import BaseSiteFactorData from '../../../BaseSiteFactorData'
import SiteQuery from '../../../../components/Data/Query/SiteQuery'
import CompletedQuery from '../../../../components/Data/Query/CompletedQuery'
import DataWrapper from '../../../../components/Data/DataWrapper'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'
import UnitSwitch from '../../../../components/Data/UnitSwitch'
import DustHazeChartGroup from './DustHazeChartGroup'
import DataFormatter from '../../../../model/DataFormatter'

export default {
  name: 'DustHazeFeatures',
  routeInfo: {
    label: '黑炭综合分析',
    icon: 'fa fa-eye'
  },
  extends: BaseSiteFactorData,
  components: {DustHazeChartGroup, UnitSwitch, DataWrapper, CompletedQuery, SiteQuery, DataTimeQuery, LayoutContent},
  data: () => ({
    count: 0,
    query: {
      isMultipleIntegral: true
    }
  }),
  computed: {
    siteDeviceCategoryConfig: () => [
      new DeviceCategoryConfig(1, true),
      new DeviceCategoryConfig(process.env.METEOROLOGICAL_DEVICE_CATEGORY, false, siteDeviceFactors => {
        return siteDeviceFactors.filter(siteDeviceFactor => /^101(0|1|2|3|4)|8000|8001$/.test(siteDeviceFactor.factorId))
      }),
      new DeviceCategoryConfig(process.env.ION_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.ZOOM_DEVICE_CATEGORY, false),
      new DeviceCategoryConfig(process.env.BLACK_CARBON_DEVICE_CATEGORY, true)
    ],
    downloadName: () => '灰霾过程特性',
    currentSite () {
      const [siteId] = this.query.siteIds
      return this.filterSites.find(site => site.id === siteId)
    },
    aggregationFactorGroups () {
      return []
    },
    factorChartGroups () {
      const {currentSite} = this

      if (currentSite) {
        const {devices} = currentSite
        const groups = devices.map(device => device.siteDeviceFactors.map(siteDeviceFactor => siteDeviceFactor.factorId))
        const groupMap = groups.reduce((map, ids, index) => ids.reduce((map, id) => {
          let group = map[id]

          if (!group) {
            group = map[id] = []
          }

          group.push(index)

          return map
        }, map), {})

        return Object.values(Object.values(this.siteFactorMap[currentSite.id].map).reduce((map, factor) => {
          const {factorId} = factor
          const groupInfos = groupMap[factorId] || groupMap[factor.parentId]

          if (groupInfos) {
            groupInfos.forEach(groupIndex => {
              let groups = map[groupIndex]

              if (!groups) {
                groups = map[groupIndex] = []
              }

              groups.push(factorId)
            })
          }

          return map
        }, {}))
      }

      return []
    }
  },
  methods: {
    getSeriesParam (dimension, dimensionIds) {
      let factorId = dimensionIds[dimension ^ 1]
      let siteId = dimensionIds[dimension]

      if (factorId === '1011') {
        return {
          type: 'bar',
          barMaxWidth: 30
        }
      } else if (factorId !== '3507' && factorId.charAt(0) === '3') {
        return {
          type: 'bar',
          stack: `${siteId}-BC`,
          barMaxWidth: 30
        }
      } else if (!/^(6917|6918)$/.test(factorId) && factorId.charAt(0) === '6') {
        return {
          type: 'bar',
          stack: `${siteId}-${(factorId | 0) < 6910 ? 'ION' : 'ION-GAS'}`,
          barMaxWidth: 30
        }
      } else {
        return {
          type: 'line',
          showSymbol: false
        }
      }
    },
    setDataList (dataList) {
      this.tmpList = Object.freeze(DataFormatter.formatWeatherDataList.bind(this)(dataList))
      this.formatData()
    },
    onChartRendered () {
      this.count++

      if (this.factorChartGroups.length === this.count && this.count > 0) {
        this.$refs['chart-groups'][0].getChartComponent().connect(this.$refs['chart-groups'].map(component => component.getChartComponent()))
        this.count = 0
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/00PM/06Dust-Haze/index.vue